var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.$q.screen.lt.md ? 'mobile' : 'desktop',{tag:"component",class:{
      'light-dimmed': _vm.loading
    },attrs:{"type":_vm.type,"location":_vm.location,"items":_vm.items,"loading":_vm.loading},on:{"location-change":_vm.locationChange,"show":_vm.show}}),_c('m-discovery-detail-modal',{ref:"detail"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }